import { memo, SVGProps } from 'react';

const PolygonIconUnder = (props: SVGProps<SVGSVGElement>) => (
  <svg preserveAspectRatio='none' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path d='M7 14L0.937823 3.5L13.0622 3.5L7 14Z' fill='#3BD4F0' stroke='#3BD4F0' strokeLinejoin='round' />
  </svg>
);

const Memo = memo(PolygonIconUnder);
export { Memo as PolygonIconUnder };
